import { useEffect, useImperativeHandle, useState } from 'react';
import Moment from 'moment';
import { isArrayEmpty, isNullOrEmpty } from '../../../../components/helpers/ObjectHelpers';
import { getPilotAssignmentStatusColor } from '../helpers/PilotAssignmentHelpers';
import { Card } from '../../../../components/layout/card/Card';

export const DurationCard = (
    {
        ref,
        assignmentService
    }) => {

    useImperativeHandle(ref, () => ({
        onLocationsChanged() {
            initialize();
        }
    }));

    const borderColor = getPilotAssignmentStatusColor(assignmentService.assignment)
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Card
            borderColor={borderColor}
            indicatorPrimaryColor={borderColor}
            showIndicator={true}>
            <div className="title">Oppdragets varighet: {formatDuration(duration)}</div>
        </Card>
    )

    function initialize() {
        const fromToTimes = assignmentService.fromAndToTimes;
        if (isArrayEmpty(fromToTimes)) {
            setDuration(0);
        } else {
            var duration = 0;
           for (const fromToTime of fromToTimes) {
                const diffMinutes = Moment(fromToTime.toTime).diff(Moment(fromToTime.fromTime), 'minutes');
                duration += diffMinutes;
           }
            setDuration(duration);
        }
    }

    function formatDuration(minutes) {
        if (!minutes || minutes <= 0) return "0 timer";
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        const hourStr = hrs === 1 ? "time" : "timer";
        const minStr = mins === 1 ? "minutt" : "minutter";
        if (hrs > 0 && mins > 0) {
            return `${hrs} ${hourStr} ${mins} ${minStr}`;
        } else if (hrs > 0) {
            return `${hrs} ${hourStr}`;
        } else {
            return `${mins} ${minStr}`;
        }
    }
}

